/**
 * @module store/state
 *
 * @version 1.0.0
 * @copyright Kosmos 2019
 */
export default {};
